export function isPrivatePerson(counterpartyType: string): boolean {
  return counterpartyType === 'PrivatePerson';
}
